<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-toolbar class="md-primary">
        <h3 class="md-title">{{ $t("User Profile") }}</h3>
      </md-toolbar>
      <br />
    </div>
    <div class="md-layout-item md-medium-size-100 md-size-100">
      <profile header-color="primary"></profile>
    </div>
    <div
      v-if="usertype !== USER_TYPE.PILOT && usertype !== USER_TYPE.SUPER"
      class="md-layout-item md-small-size-100 md-size-50"
      style="padding-bottom: 15px"
    >
      <payment header-color="primary"></payment>
    </div>
    <div
      v-if="usertype !== USER_TYPE.PILOT && usertype !== USER_TYPE.SUPER"
      class="md-layout-item md-small-size-100 md-size-50"
    >
      <md-card v-blur="blur">
        <md-card-header class="md-card-header-text md-card-header-primary">
          <div class="card-text" style="display: block;background: grey;">
            <!--<md-icon>list_alt</md-icon>-->
            <h4 class="title" style="color: white;">
              {{ $t("Subscription") }}
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-100">
              <!-- <br />
              <span style="color: red; font-weight: 500;">{{ $t("We do not accept new subscriber any more.") }}</span>
              <br />
              <br /> -->
              <div v-if="usertype == USER_TYPE.MAAC">
                {{ $t("Plan") + ": " }}<b>MAAC</b
                >{{ cancelled ? " (" + $t("Cancelled") + ")" : "" }}<br />
                {{ $t("Frequency") + ": " }}
                <b>{{
                  plan_freq === "y"
                    ? $t("Yearly")
                    : plan_freq === "m"
                    ? $t("Monthly")
                    : "N/A"
                }}</b
                ><br />
                {{ $t("Max. Pilot") + ": "
                }}<b>{{ quantity > 0 ? quantity : "1" }}</b
                ><br />
              </div>
              <div v-else>
                {{ $t("Plan") + ": " }}<b>{{ plan_type ? plan_type : "N/A" }}</b
                >{{ cancelled ? " (" + $t("Cancelled") + ")" : "" }}<br />
                {{ $t("Frequency") + ": " }}
                <b>{{
                  plan_freq === "y"
                    ? $t("Yearly")
                    : plan_freq === "m"
                    ? $t("Monthly")
                    : "N/A"
                }}</b
                ><br />
                {{ $t("Max. Pilot") + ": "
                }}<b>{{ quantity > 0 ? quantity : "1" }}</b
                ><br />
              </div>

              <br />
              <div v-if="usertype !== USER_TYPE.FREE">
                <i class="md-icon md-icon-font md-theme-default">schedule</i
                >&nbsp;
                <span
                  >{{ $t("Current billing cycle") + ": " }}
                  <b
                    ><span v-if="plan_type !== undefined"
                      >{{ current_period_start_date }} -
                      {{ current_period_end_date }}</span
                    >
                    <span v-else>N/A</span></b
                  ></span
                >
                <br />
                <a
                  href="#/Subscription"
                  style="margin-bottom:10px"
                  class="md-button md-raised md-primary mt-4 md-theme-default"
                >
                  <div class="md-ripple">
                    <div
                      class="md-button-content"
                      v-if="
                        plan_type !== undefined &&
                          plan_type !== '' &&
                          !cancelled
                      "
                    >
                      {{ $t("Edit") }}
                    </div>
                    <div class="md-button-content" v-else>
                      {{ $t("Subscribe") }}
                    </div>
                  </div>
                </a>
                <md-button
                  v-if="!cancelled"
                  href="javascript:void(0)"
                  class="md-default md-raised mt-4"
                  :disabled="plan_type === undefined"
                  @click="cancel"
                  style="margin-left:20px"
                  >{{ $t("Cancel") }}</md-button
                >
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Profile, Payment } from "@/pages";
import { mapFields } from "vuex-map-fields";
import { EventBus } from "@/helpers";
import { USER_TYPE } from "@/const.js";
import swal from "sweetalert2";

export default {
  components: {
    Profile,
    Payment
  },
  computed: {
    blur: function() {
      return this.editing;
    },
    ...mapFields("auth", [
      "usertype",
      "plan_type",
      "plan_freq",
      "cancelled",
      "quantity",
      "registered_on",
      "current_period_start_date",
      "current_period_end_date"
    ]),
    ...mapFields("stats", [
      "surveyLabels",
      "surveySeries",
      "maxSurveyCount",
      "freeTrial",
      "pilotLabels",
      "pilotSeries",
      "maxPilotCount",
      "totalCount",
      "controlledLabels",
      "controlledSeries",
      "totalMissions",
      "totalHours"
    ])
  },
  data() {
    return {
      USER_TYPE: USER_TYPE,
      editing: false
    };
  },
  beforeMount() {
    this.$store.dispatch("subscription/retrieveSubscription");
    this.freeTrial = 8 - this.maxSurveyCount;
  },
  mounted() {
    EventBus.$on("canceledSubscription", () => {
      swal.fire({
        title: this.$t("Confirmation"),
        text: this.$t("You successfully canceled subscription!"),
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    });
  },
  beforeDestroy() {
    EventBus.$off("canceledSubscription");
  },
  methods: {
    cancel() {
      if (this.pilotQuantity > 1) {
        swal.fire({
          title: this.$t("Failed to cancel subscription!"),
          text: this.$t(
            "There are more than one pilot in your account. Free plan can only have one pilot. Please remove other pilots before cancelling your subscription."
          ),
          type: "error",
          confirmButtonClass: "md-button md-error",
          buttonsStyling: false
        });
        return;
      }

      swal
        .fire({
          title: this.$t("Are you sure you want to cancel subscription?"),
          text: this.$t("We are so sorry to see you leave."),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: this.$t("Yes"),
          cancelButtonText: this.$t("Cancel"),
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store.dispatch("subscription/cancelSubscription");

            this.enterpriseIcon = "shopping_cart";
            this.proIcon = "shopping_cart";
          }
        });
    }
  }
};
</script>
<style lang="scss"></style>
